/*
*
* File JS per la Single Magazine
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroImage from 'imComponents/hero-image/hero-image';
import blockDownload from 'components/block-download/block-download';

// COMPONENTI CUSTOM BLOCKS
import blockText from 'components/block-text/block-text';
import blockImage from 'components/block-image/block-image';
import scrollBanner from 'components/scroll-banner/scroll-banner';
import blockGallery from 'components/block-gallery/block-gallery';
import blockAltTextImage from 'components/block-alt-text-image/block-alt-text-image';
import blockEmbed from 'imComponents/block-embed/block-embed';
import blockVideo from 'imComponents/block-video/block-video';

// RELAZIONI
import bannerPlace from 'components/banner-place/banner-place';
import cardGuest from 'components/card-guest/card-guest';
import blockEventGuests from 'components/block-event-guests/block-event-guests';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-magazine.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

blockGallery();
blockVideo();

//--------------------------------------------------------------------//